import CartGoodsBlockNew from './CartGoodsBlockNew'

export default CartGoodsBlockNew
